/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsThread,
    AssetsMelcoModelsThreadFromJSON,
    AssetsMelcoModelsThreadFromJSONTyped,
    AssetsMelcoModelsThreadToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoModelsThread
 */
export interface AssetsMelcoModelsGenericList1MelcoModelsThread {
    /**
     * 
     * @type {Array<AssetsMelcoModelsThread>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsThread
     */
    list: Array<AssetsMelcoModelsThread>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsThread
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsThread
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoModelsThreadFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoModelsThread {
    return AssetsMelcoModelsGenericList1MelcoModelsThreadFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoModelsThreadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoModelsThread {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoModelsThreadFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoModelsThreadToJSON(value?: AssetsMelcoModelsGenericList1MelcoModelsThread | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoModelsThreadToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


